// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b5e4616","239":"b9953411","453":"0b35aaf7","732":"9d9c04ce"}[chunkId] + ".chunk.js";
};